import { Autocomplete } from "@react-google-maps/api";
import { t } from "i18next";
import React, { useRef } from 'react';


const AddressForm = ({ address, setAddress, goToNextStep }) => {
    const startAddressRef = useRef();
    const endAddressRef = useRef();

    const handlePlaceSelect = (addressType, ref) => {
        if (!ref.current) return;

        const place = ref.current.getPlace();
        if (!place?.geometry) {
            return;
        }

        const addressComponents = place.address_components;
        const getAddressComponent = (type, short = false) => {
            const component = addressComponents.find(comp => comp.types.includes(type));
            return short ? component?.short_name || '' : component?.long_name || '';
        };

        const newAddress = {
            number: getAddressComponent('street_number'),
            street: getAddressComponent('route'),
            city: getAddressComponent('locality'),
            country: getAddressComponent('country'),
            countryCode: getAddressComponent('country', true),
            postalCode: getAddressComponent('postal_code'),
            label: place.formatted_address,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };

        setAddress(prevAddress => ({
            ...prevAddress,
            [addressType]: newAddress
        }));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setAddress(address);
        goToNextStep();
    };

    return (
        <form
            style={{
                background: '#e0e0e0',
                padding: '20px',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
            }}
            onSubmit={handleSubmit}
        >
            <div style={{ marginBottom: '10px' }}>
                <label>{t('addressForm:pickupAddress')}</label>
                <Autocomplete
                    onLoad={(ref) => startAddressRef.current = ref}
                    onPlaceChanged={() => handlePlaceSelect('startAddress', startAddressRef)}
                >
                    <input
                        type="text"
                        value={address?.startAddress?.label}
                        onChange={(e) => setAddress({ ...address, startAddress: e.target.value })}
                        style={{ width: 'calc(100% - 20px)', padding: '10px' }}
                    />
                </Autocomplete>
            </div>
            <div style={{ marginBottom: '10px' }}>
            <label>{t('addressForm:deliveryAddress')}</label>
                <Autocomplete
                    onLoad={(ref) => endAddressRef.current = ref}
                    onPlaceChanged={() => handlePlaceSelect('endAddress', endAddressRef)}
                >
                    <input
                        type="text"
                        value={address?.endAddress?.label}
                        onChange={(e) => setAddress({ ...address, endAddress: e.target.value })}
                        onKeyDown={handleKeyDown}
                        style={{ width: 'calc(100% - 20px)', padding: '10px' }}
                    />
                </Autocomplete>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'end',
                }}
            >
                <button
                    className="homepage-button"
                    style={{
                        width: '120px',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '4px',
                    }}
                    type="submit"
                    disabled={!address?.startAddress?.lat || !address?.endAddress?.lat}
                >
                    {t('common:next')}
                </button>
            </div>
        </form>
    );
}

export default AddressForm;
